module.exports = __webpack_public_path__ + "img/instagram.e4a301fd.svg";